var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bar"},[_c('div',{staticClass:"flex-y-conter"},[_vm._t("icon",function(){return [(_vm.icon)?_c('img',{staticClass:"title-icon",attrs:{"src":_vm.icon}}):_vm._e()]}),_c('span',{staticClass:"title-txt"},[_vm._v(_vm._s(_vm.title))])],2),_c('div',[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }